import { Link } from "react-router-dom";
import { getHot } from "@/utils/video-utils";
import { usePlayNotice } from "@/components/feature/PlayNotice";

export default function HotGrid() {
  const list = getHot(6);
  const { showPlayNotice } = usePlayNotice();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热门影视精选</h2>
          <p className="mt-2 text-sm text-foreground-600">本季口碑与热度兼具的优质内容，不容错过</p>
        </div>
        <Link
          to="/search"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {list.map((video) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group flex gap-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-500/60 transition-colors overflow-hidden cursor-pointer"
          >
            <div className="relative w-28 md:w-32 shrink-0 aspect-[2/3] overflow-hidden bg-background-200">
              <img
                src={video.poster}
                alt={`${video.title} 封面`}
                title={`${video.title} - 嫩草视频热门精选`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  showPlayNotice(video.title);
                }}
                aria-label={`播放 ${video.title}`}
                className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                  <i className="ri-play-fill text-xl"></i>
                </span>
              </button>
            </div>
            <div className="flex-1 min-w-0 p-3 md:p-4 flex flex-col">
              <div className="flex items-center gap-2">
                <span className="text-xs text-primary-500 bg-primary-500/10 px-2 py-0.5 rounded">
                  {video.category}
                </span>
                <span className="flex items-center gap-0.5 text-xs text-accent-400">
                  <i className="ri-star-fill"></i>
                  {video.rating.toFixed(1)}
                </span>
              </div>
              <h3 className="mt-2 text-base font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                {video.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-600">
                {video.genres.join(" / ")} · {video.region} · {video.year}
              </p>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2 md:line-clamp-3">
                {video.summary}
              </p>
              <span className="mt-auto pt-3 text-xs text-foreground-700 flex items-center gap-1">
                查看详情
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}